<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="640"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="下载 Profile"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        :form="form"
        @submit="handleSubmit"
      >
        <a-form-item label="EID">
          <span>{{ eid }}</span>
        </a-form-item>

        <a-form-item label="ICCID">
          <a-select
            v-decorator="['iccid', { rules: [{ required: true, message: '请选择ICCID' }] }]"
            :show-arrow="false"
            show-search
            allow-clear
            :filter-option="false"
            :not-found-content="loadingProfileOptions ? undefined : null"
            placeholder="输入ICCID加载选项"
            :loading="loadingProfileOptions"
            @search="fetchProfileOptions"
          >
            <a-spin v-if="loadingProfileOptions" slot="notFoundContent" size="small" />
            <a-select-option
              v-for="opt in profileOptions"
              :key="opt.iccid"
              :value="opt.iccid"
            >
              {{ opt.iccid }}（{{ opt.status_name || opt.status || '-' }}）
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="下载后激活">
          <a-select
            :loading="loadingAutoEnable"
            placeholder="请选择"
            v-decorator="['auto_enable_type', {
              rules: [{ required: true, message: '请选择下载后激活选项' }],
              initialValue: defaultAutoEnableType
            }]"
          >
            <a-select-option
              v-for="opt in autoEnableOptions"
              :key="opt.id"
              :value="Number(opt.sub_type_slug)"
            >
              {{ opt.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { downloadEsimProfile } from '@/api/esim'
import { findDownloadableProfileOptions } from '@/api/profile'
import { findCommonTypeOptions } from '@/api/common_type'

export default {
  name: 'DownloadEsimProfile',
  props: {
    visible: { type: Boolean, required: true },
    esimId: { type: Number, required: true },
    eid: { type: String, default: '' },
    agentId: { type: Number, required: true }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      submitting: false,
      loadingProfileOptions: false,
      loadingAutoEnable: false,
      profileOptions: [],
      autoEnableOptions: [],
      defaultAutoEnableType: 0
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.loadAutoEnableOptions()
  },
  methods: {
    loadAutoEnableOptions() {
      this.loadingAutoEnable = true
      findCommonTypeOptions('profile_download_auto_enable').then((res) => {
        if (res.code === 0) {
          this.autoEnableOptions = res.data || []
          const off = this.autoEnableOptions.find((o) => String(o.sub_type_slug) === '0')
          this.defaultAutoEnableType = off ? 0 : (this.autoEnableOptions[0] ? Number(this.autoEnableOptions[0].sub_type_slug) : 0)
        }
        this.loadingAutoEnable = false
      }).catch(() => {
        this.loadingAutoEnable = false
      })
    },
    fetchProfileOptions(keyword) {
      if (!this.$lodash.trim(keyword)) {
        return
      }
      this.loadingProfileOptions = true
      findDownloadableProfileOptions(this.agentId, {
        iccid: this.$lodash.trim(keyword)
      }).then((res) => {
        if (res.code === 0) {
          this.profileOptions = res.data || []
        }
        this.loadingProfileOptions = false
      }).catch(() => {
        this.loadingProfileOptions = false
      })
    },
    handleSubmit(e) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.submitting = true
        downloadEsimProfile(this.esimId, {
          iccid: values.iccid,
          auto_enable_type: values.auto_enable_type
        }).then((res) => {
          this.submitting = false
          if (res.code === 0) {
            const d = res.data || {}
            const msg = d.message || '下载指令已提交，等待执行结果'
            const tip = d.task_id ? `${msg}（任务#${d.task_id}）` : msg
            this.$message.success(tip)
            this.isShow = false
            this.$emit('completed')
          }
        }).catch(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>
